import { BoxProps, TextNewProps } from '@jfs/ui-new'
import { zIndex } from './DropdownConstants'
import { DropdownTypes } from './types'

const shadowStyle = {
  shadowOffset: { width: 1, height: 1 },
  shadowRadius: 3,
  shadowColor: '#0000001F',
  borderRadius: 8,
  borderWidth: 1,
  borderColor: '#00000014',
  zIndex: 10,
}

const styles = {
  modal: {
    flex: 1,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100%',
    width: '100%',
    zIndex: 10,
    underlayColor: 'TRANSPARENT',
    zindex: zIndex,
    overflow: 'hidden',
  } as BoxProps,
  dropdownContainer: {
    bg: 'WHITE',
    alignSelf: 'flex-start',
    ...(shadowStyle as BoxProps),
    borderRadius: 4,
  } as BoxProps,
  defaultDropdown: {
    pv: 10,
    ph: 16,
    underlayColor: 'LIGHTEST_GREY_2',
    borderBottomWidth: 1,
    borderBottomColor: 'LIGHTEST_GREY_2',
  } as BoxProps,
  defaultTextStyle: {
    color: 'BLACK',
    type: 'body12',
    fontFamily: 'jiotype-medium',
    fontWeight: '400',
    textAlign: 'left',
  } as TextNewProps,
  exportBox: {
    ph: 10,
  } as BoxProps,
  dropdownBox: (
    showBorder: boolean | undefined,
    isIconAvailable: boolean | undefined,
    borderColor: any,
    boxHeight: number,
    bgColor?: any,
    type?: any,
  ) =>
    ({
      flexDirection: 'row',
      borderWidth: showBorder ? 1 : 0,
      borderTopLeftRadius: type && type === DropdownTypes.DEFAULT_DOWNLOAD_REPORT ? 0 : 4,
      borderBottomLeftRadius: type && type === DropdownTypes.DEFAULT_DOWNLOAD_REPORT ? 0 : 4,
      borderTopRightRadius: type && type === DropdownTypes.DEFAULT_DOWNLOAD_REPORT ? 4 : undefined,
      borderBottomRightRadius: type && type === DropdownTypes.DEFAULT_DOWNLOAD_REPORT ? 4 : undefined,
      borderRadius: isIconAvailable ? 0 : 4,
      borderColor: borderColor,
      height: boxHeight,
      pr: 20,
      pl: isIconAvailable ? 20 : 0,
      underlayColor: 'TRANSPARENT',
      bg: bgColor,
    } as BoxProps),
  overlayStyle: {
    underlayColor: 'TRANSPARENT',
    position: 'absolute',
    width: '100%',
    height: '100%',
    bg: 'TRANSPARENT',
    zIndex: zIndex,
  } as BoxProps,
  iconContainer: {
    justifyContent: 'center',
    position: 'absolute',
    left: 8,
    alignSelf: 'center',
    f: 1,
    height: '100%',
  } as BoxProps,
  dropdownIconContainer: {
    justifyContent: 'center',
    position: 'absolute',
    right: 5,
    alignSelf: 'center',
    height: '100%',
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  label: {
    type: 'body12',
    fontFamily: 'jiotype-medium',
    fontWeight: '400',
  } as TextNewProps,
  labelContainer: {
    justifyContent: 'center',
    pr: 10,
  } as BoxProps,
}

export { styles }
